"use strict";
/**
 * @description: 系统应用配置文件
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSocketPath = exports.getApiPath = exports.prod = exports.development = void 0;
/**
 * @description 开发环境配置
 */
var development = {
    server: {
        baseurl: 'https://app.carecancer.cn',
        // socket url
        socketurl: "wss://app.carecancer.cn"
    },
    microApps: [{
            url: "http://127.0.0.1:9001",
            name: "doctor",
            path: "/doctor",
            description: "医生端后台管理系统"
        }]
};
exports.development = development;
/**
 * @description 生产环境配置
 */
// const prod = {
//     server: {
//         // 服务端url
//         baseurl: 'https://qljktest.vvv6g.cn',
//         // socket url
//         socketurl: "wss://qljktest.vvv6g.cn"
//     },
//     microApps: [{
//         url: "http://qljkpro.vvv6g.cn",
//         name: "doctor",
//         path: "/doctor",
//         description: "医生端后台管理系统"
//     }]
// }
var prod = {
    server: {
        // 服务端url
        baseurl: 'https://app.carecancer.cn',
        // socket url
        socketurl: "wss://app.carecancer.cn"
    },
    microApps: [{
            url: "https://doctor.carecancer.cn",
            name: "doctor",
            path: "/doctor",
            description: "医生端后台管理系统"
        }]
};
exports.prod = prod;
// const prod = {
//     server: {
//         // 服务端url
//         baseurl: 'https://app.carecancer.cn',
//         // socket url
//         socketurl: "wss://app.carecancer.cn"
//     },
//     microApps: [{
//         url: "http://qljkpro.vvv6g.cn",
//         name: "doctor",
//         path: "/doctor",
//         description: "医生端后台管理系统"
//     }]
// }
/**
 * @description 获取api path
 */
var getApiPath = function () {
    return process.env.NODE_ENV === 'development' ? development.server.baseurl : prod.server.baseurl;
};
exports.getApiPath = getApiPath;
/**
 * @description 获取socket url
 */
var getSocketPath = function () {
    return process.env.NODE_ENV === 'development' ? development.server.socketurl : prod.server.socketurl;
};
exports.getSocketPath = getSocketPath;
